var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMentalHealth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Brain-Head-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Brain Head 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.43 9.86a7.46 7.46 0 0 1 -0.72 -1.45c0 -5.27 -4.87 -8.41 -9.57 -8.41a9.93 9.93 0 0 0 -10 10.06c0 3.5 1.27 6.13 3.78 7.82a0.48 0.48 0 0 1 0.22 0.41v5.21a0.5 0.5 0 0 0 0.5 0.5h10a0.5 0.5 0 0 0 0.5 -0.5v-3a0.5 0.5 0 0 1 0.5 -0.5h1.5a2.5 2.5 0 0 0 2.5 -2.5v-2a0.5 0.5 0 0 1 0.5 -0.5h0.55a1.3 1.3 0 0 0 1 -0.52 1.27 1.27 0 0 0 0.19 -0.75 7.7 7.7 0 0 0 -1.45 -3.87Zm-7 0.13a0.48 0.48 0 0 0 -0.45 0.19 3.55 3.55 0 0 1 -2.38 1.3 0.49 0.49 0 0 0 -0.39 0.27A4 4 0 0 1 7.64 14a4.14 4.14 0 0 1 -4 -4.25 4.36 4.36 0 0 1 1.45 -3.27 0.54 0.54 0 0 0 0.16 -0.26A3.49 3.49 0 0 1 8.64 3.5a3.31 3.31 0 0 1 0.83 0.1 0.5 0.5 0 0 0 0.53 -0.14 3 3 0 0 1 2.18 -1 3 3 0 0 1 2.48 1.3A0.51 0.51 0 0 0 15 4a3 3 0 0 1 -0.6 6Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMentalHealth);
export default ForwardRef;